if (!customElements.get('brush-tech-arrows')) {
  customElements.define('brush-tech-arrows', class extends HTMLElement {
    connectedCallback() {
      this.layout = this.parentElement;
      this.track = this.layout.querySelector('.brush-tech-cards');
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.draw());
      };
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.layout);
      this.layout.querySelectorAll('img, .brush-tech-card').forEach(el => this.observer.observe(el));
      this.track.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      this.schedule();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.track?.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      cancelAnimationFrame(this.frame);
    }
    draw() {
      const image = this.layout.querySelector('.brush-tech-center');
      if (!image) return;
      const base = this.layout.getBoundingClientRect();
      const target = image.getBoundingClientRect();
      const mobile = window.matchMedia('(max-width: 989px)').matches;
      const clip = this.track.getBoundingClientRect();
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', `0 0 ${base.width} ${mobile ? 38 : base.height}`);
      svg.setAttribute('aria-hidden', 'true');
      const color = this.dataset.color || '#ba913f';
      if (mobile) {
        const middle = base.width / 2;
        const line = document.createElementNS(ns, 'path');
        line.setAttribute('class', 'brush-tech-arrow-line');
        line.setAttribute('d', 'M ' + (middle + 20) + ' 35 C ' + (middle - 24) + ' 26, ' + (middle - 22) + ' 14, ' + middle + ' 3 M ' + (middle - 8) + ' 4 L ' + middle + ' 3 L ' + (middle - 3) + ' 11');
        svg.append(line);
        this.replaceChildren(svg);
        return;
      }
      this.layout.querySelectorAll('.brush-tech-card').forEach((card, index) => {
        const box = card.getBoundingClientRect();
        let sx, sy, ex, ey, c1x, c1y, c2x, c2y;
        if (mobile) {
          const visibleLeft = Math.max(box.left, clip.left);
          const visibleRight = Math.min(box.right, clip.right);
          if (visibleRight - visibleLeft < 50) return;
          sx = (visibleLeft + visibleRight) / 2 - base.left;
          sy = box.top - base.top - 3;
          ex = target.left + target.width / 2 - base.left;
          ey = target.bottom - base.top + 4;
          c1x = sx + (sx < ex ? -22 : 22);
          c1y = sy - 32;
          c2x = ex + (sx < ex ? -28 : 28);
          c2y = ey + 30;
        } else {
          const left = card.classList.contains('brush-tech-card--left');
          const direction = left ? 1 : -1;
          sx = (left ? box.right : box.left) - base.left + direction * 3;
          sy = box.top + box.height / 2 - base.top;
          ex = (left ? target.left : target.right) - base.left - direction * 5;
          ey = Math.max(target.top + 16, Math.min(target.bottom - 16, box.top + box.height / 2)) - base.top;
          const bend = index % 3 === 1 ? 22 : (index % 3 === 0 ? -24 : 24);
          c1x = sx + direction * 24;
          c1y = sy + bend;
          c2x = ex - direction * 22;
          c2y = ey + bend;
        }
        const line = document.createElementNS(ns, 'path');
        line.setAttribute('class', 'brush-tech-arrow-line');
        line.setAttribute('d', `M ${sx} ${sy} C ${c1x} ${c1y}, ${c2x} ${c2y}, ${ex} ${ey}`);
        svg.append(line);
        const angle = Math.atan2(ey - c2y, ex - c2x);
        const size = 8;
        const head = document.createElementNS(ns, 'path');
        head.setAttribute('class', 'brush-tech-arrow-line');
        head.setAttribute('stroke', color);
        head.setAttribute('d', `M ${ex - size * Math.cos(angle - .5)} ${ey - size * Math.sin(angle - .5)} L ${ex} ${ey} L ${ex - size * Math.cos(angle + .5)} ${ey - size * Math.sin(angle + .5)}`);
        svg.append(head);
      });
      this.replaceChildren(svg);
    }
  });
}
